import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/About.vue")
    },
    {
      path: "/custom",
      name: "custom",
      component: () => import("./views/Custom.vue")
    },
    {
      path: "/projects",
      name: "projects",
      component: () => import("./views/Projects.vue")
    },
    {
      path: "/editions",
      name: "editions",
      component: () => import("./views/Editions.vue")
    },
    {
      path: "/editions/:id",
      name: "edition",
      component: () => import("./views/Edition.vue"),
      props: true
    },
    {
      path: "/store",
      name: "store",
      component: () => import("./views/Store.vue")
    },
    {
      path: "/store/:id",
      name: "shopitem",
      component: () => import("./views/ShopItem.vue"),
      props: true
    },
    {
      path: "/terms",
      name: "terms",
      component: () => import("./views/Terms.vue")
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
